(function(){
  'use strict';

  var roots=document.querySelectorAll('.saturn-enterprise[data-section-id]');
  for(var ri=0;ri<roots.length;ri++)init(roots[ri]);

  function init(root){
    var sid=root.getAttribute('data-section-id');
    var get=function(name){return document.getElementById(name+'-'+sid);};
    var month=get('saturn-month');
    var day=get('saturn-day');
    var year=get('saturn-year');
    var calculate=get('saturn-calculate');
    var error=get('saturn-error');
    var form=get('saturn-form');
    var restore=get('saturn-restore');
    var result=get('saturn-result');
    var resultTitle=get('saturn-result-title');
    var resultLead=get('saturn-result-lead');
    var resultOverline=get('saturn-result-overline');
    var metrics=get('saturn-metrics');
    var returns=get('saturn-returns');
    var phaseBadge=get('saturn-phase-badge');
    var phaseCopy=get('saturn-phase-copy');
    var recalculate=get('saturn-recalculate');
    var offer=get('saturn-reading-offer');
    var offerHeading=root.querySelector('[data-saturn-offer-heading]');
    var offerCopy=root.querySelector('[data-saturn-offer-copy]');
    var sticky=get('saturn-sticky');
    var selectedFocus={value:'overall',label:'Overall',phrase:''};
    var selectedTier='deeper';
    var readingState=null;
    var offerVisible=false;
    var recoveryVisible=false;
    var DAY=86400000;
    var YEAR=365.2425;
    var STORAGE_KEY='deckaura.saturnReturn.v3';
    var SIGNS=['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
    var PACKAGE_NAMES={essential:'Saturn Signal',deeper:'Saturn Focus Map',indepth:'Saturn Return Blueprint'};
    var PACKAGE_FEATURES={
      essential:['Current phase and central lesson','One grounded next step'],
      deeper:['Every Saturn signal considered','Keep, restructure or release · 90-day direction'],
      indepth:['Full return-timeline synthesis','Alternatives, risks, safeguards · 30-day plan']
    };
    var SIGN_THEMES={
      Aries:'disciplined courage and action you can sustain',
      Taurus:'stable values, money and foundations that can last',
      Gemini:'clear choices, honest communication and mental focus',
      Cancer:'emotional boundaries, home and a stronger sense of safety',
      Leo:'creative authority, visibility and leadership from the heart',
      Virgo:'useful routines, skill and standards that support your life',
      Libra:'mature partnership, fair commitments and decisive boundaries',
      Scorpio:'trust, shared power and the courage to release an old structure',
      Sagittarius:'belief, direction and a vision grounded in real practice',
      Capricorn:'authority, ambition and responsibility on your own terms',
      Aquarius:'community, independence and a future with workable structure',
      Pisces:'compassion, spiritual discipline and boundaries that protect your energy'
    };
    var fieldNodes={month:month,day:day,year:year};
    var fieldErrors={
      month:root.querySelector('[data-saturn-error-for="month"]'),
      day:root.querySelector('[data-saturn-error-for="day"]'),
      year:root.querySelector('[data-saturn-error-for="year"]')
    };

    function track(name,data){
      var payload=data||{};
      try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name},payload));}catch(_e){}
      try{if(typeof window.clarity==='function')window.clarity('event',name);}catch(_e){}
    }
    function reduceMotion(){
      try{return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(_e){return false;}
    }
    function scrollTo(target){
      if(!target)return;
      try{
        var top=target.getBoundingClientRect().top+(window.scrollY||window.pageYOffset||0)-110;
        window.scrollTo({top:Math.max(0,top),behavior:reduceMotion()?'auto':'smooth'});
      }catch(_e){target.scrollIntoView();}
    }
    function norm(value){value%=360;return value<0?value+360:value;}
    function diff180(value){return ((value+540)%360)-180;}
    function julian(date){return date.getTime()/DAY+2440587.5;}
    function precession(date){
      var t=(julian(date)-2451545)/36525;
      return (5028.796195*t+1.1054348*t*t)/3600;
    }
    function longitudeValue(ecliptic){
      if(ecliptic.elon!=null)return ecliptic.elon;
      if(ecliptic.lon!=null)return ecliptic.lon;
      return ecliptic.longitude;
    }
    function saturnLongitude(date){
      var astronomy=window.Astronomy;
      var vector=astronomy.GeoVector(astronomy.Body.Saturn,date,true);
      return norm(longitudeValue(astronomy.Ecliptic(vector))+precession(date));
    }
    function bisect(d1,d2,natal){
      for(var i=0;i<40;i++){
        var mid=new Date((d1.getTime()+d2.getTime())/2);
        var fm=diff180(saturnLongitude(mid)-natal);
        var f1=diff180(saturnLongitude(d1)-natal);
        if((f1<=0&&fm>=0)||(f1>=0&&fm<=0))d2=mid;else d1=mid;
      }
      return new Date((d1.getTime()+d2.getTime())/2);
    }
    function findReturns(birth,natal,startYear,endYear){
      var crossings=[];
      var previous=null;
      var previousDate=null;
      var start=birth.getTime()+startYear*YEAR*DAY;
      var end=birth.getTime()+endYear*YEAR*DAY;
      for(var time=start;time<=end;time+=7*DAY){
        var date=new Date(time);
        var current=diff180(saturnLongitude(date)-natal);
        if(previous!==null&&Math.abs(current-previous)<60&&((previous<0&&current>=0)||(previous>0&&current<=0)))crossings.push(bisect(previousDate,date,natal));
        previous=current;
        previousDate=date;
      }
      return crossings;
    }
    function formatMonth(date){return date.toLocaleDateString('en-US',{month:'long',year:'numeric'});}
    function formatDay(date){return date.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});}
    function formatRange(list){
      if(!list.length)return 'Unavailable';
      if(list.length===1)return formatMonth(list[0]);
      return formatMonth(list[0])+' – '+formatMonth(list[list.length-1]);
    }
    function formatBirth(iso){
      var parts=String(iso||'').split('-');
      if(parts.length!==3)return'';
      return new Date(Date.UTC(Number(parts[0]),Number(parts[1])-1,Number(parts[2]),12)).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
    }
    function ageAt(birth,date){return Math.round((date.getTime()-birth.getTime())/(YEAR*DAY));}
    function statusFor(list,now){
      if(!list.length)return 'Unavailable';
      var start=new Date(list[0].getTime()-90*DAY);
      var end=new Date(list[list.length-1].getTime()+90*DAY);
      if(now>=start&&now<=end)return 'Active now';
      return list[list.length-1]<now?'Completed':'Upcoming';
    }
    function clearValidation(){
      error.textContent='';
      Object.keys(fieldNodes).forEach(function(key){
        fieldNodes[key].removeAttribute('aria-invalid');
        fieldErrors[key].textContent='';
      });
    }
    function clearFieldValidation(node){
      error.textContent='';
      Object.keys(fieldNodes).forEach(function(key){
        if(fieldNodes[key]!==node)return;
        fieldNodes[key].removeAttribute('aria-invalid');
        fieldErrors[key].textContent='';
      });
    }
    function setFieldError(key,message){
      fieldNodes[key].setAttribute('aria-invalid','true');
      fieldErrors[key].textContent=message;
    }
    function firstInvalidField(){
      var keys=['month','day','year'];
      for(var i=0;i<keys.length;i++)if(fieldNodes[keys[i]].getAttribute('aria-invalid')==='true')return fieldNodes[keys[i]];
      return month;
    }
    function invalidateResult(){
      readingState=null;
      result.hidden=true;
      sticky.hidden=true;
      try{if(window.DeckauraDeepReading&&typeof window.DeckauraDeepReading.disable==='function')window.DeckauraDeepReading.disable();}catch(_e){}
    }
    function parseBirth(showMessage){
      clearValidation();
      var mm=String(month.value||'').replace(/\D/g,'').slice(0,2);
      var dd=String(day.value||'').replace(/\D/g,'').slice(0,2);
      var yyyy=String(year.value||'').replace(/\D/g,'').slice(0,4);
      day.value=dd;year.value=yyyy;
      var invalid=false;
      var m=parseInt(mm,10);
      var d=parseInt(dd,10);
      var current=new Date();
      var currentYear=current.getFullYear();
      if(yyyy.length===2){
        var shortYear=parseInt(yyyy,10);
        yyyy=String(shortYear<=currentYear%100?2000+shortYear:1900+shortYear);
        year.value=yyyy;
      }
      var y=parseInt(yyyy,10);

      if(!mm){setFieldError('month','Choose a month.');invalid=true;}
      if(!dd){setFieldError('day','Enter the day.');invalid=true;}
      else if(d<1||d>31){setFieldError('day','Day must be between 1 and 31.');invalid=true;}
      if(!yyyy){setFieldError('year','Enter the year.');invalid=true;}
      else if(yyyy.length!==4){setFieldError('year','Enter a four-digit year, for example 1990.');invalid=true;}
      else if(y<1920){setFieldError('year','This calculator supports birth years from 1920.');invalid=true;}
      else if(y>currentYear){setFieldError('year','Birth year cannot be in the future.');invalid=true;}

      if(!invalid&&m>=1&&m<=12){
        var daysInMonth=new Date(Date.UTC(y,m,0)).getUTCDate();
        if(d>daysInMonth){
          var monthName=new Date(Date.UTC(y,m-1,1)).toLocaleDateString('en-US',{month:'long'});
          setFieldError('day',monthName+' '+y+' has '+daysInMonth+' days.');
          invalid=true;
        }
      }
      var birth=invalid?null:new Date(Date.UTC(y,m-1,d,12,0,0));
      if(!invalid&&birth>current){
        setFieldError('day','Birth date cannot be in the future.');
        invalid=true;
      }
      if(invalid){
        if(showMessage)error.textContent='Please correct the highlighted birth-date field.';
        return null;
      }
      return {date:birth,iso:String(y)+'-'+String(m).padStart(2,'0')+'-'+String(d).padStart(2,'0')};
    }
    function clear(node){while(node.firstChild)node.removeChild(node.firstChild);}
    function create(tag,className,text){
      var node=document.createElement(tag);
      if(className)node.className=className;
      if(text!=null)node.textContent=text;
      return node;
    }
    function metric(label,value,note){
      var card=create('article','se-metric');
      card.appendChild(create('span','',label));
      card.appendChild(create('strong','',value));
      card.appendChild(create('small','',note));
      return card;
    }
    function returnCard(label,list,status,birth,relevant){
      var card=create('article','se-return-card'+(relevant?' is-relevant':''));
      var top=create('div','se-return-top');
      top.appendChild(create('span','',label));
      top.appendChild(create('em','',status));
      card.appendChild(top);
      card.appendChild(create('h4','',formatRange(list)));
      var age='Exact passes unavailable';
      if(list.length){
        var firstAge=ageAt(birth,list[0]);
        var lastAge=ageAt(birth,list[list.length-1]);
        age=firstAge===lastAge?'Around age '+firstAge:'Around ages '+firstAge+'–'+lastAge;
      }
      card.appendChild(create('p','',age));
      var passes=create('ul','se-pass-list');
      for(var i=0;i<list.length;i++)passes.appendChild(create('li','',formatDay(list[i])));
      card.appendChild(passes);
      return card;
    }
    function chooseChapter(firstStatus,secondStatus){
      if(firstStatus==='Upcoming')return {label:'Before first return',relevant:'First Saturn Return',status:firstStatus};
      if(firstStatus==='Active now')return {label:'First return active',relevant:'First Saturn Return',status:firstStatus};
      if(secondStatus==='Upcoming')return {label:'Between returns',relevant:'Second Saturn Return',status:secondStatus};
      if(secondStatus==='Active now')return {label:'Second return active',relevant:'Second Saturn Return',status:secondStatus};
      return {label:'After second return',relevant:'Second Saturn Return',status:secondStatus};
    }
    function phaseTextFor(chapter,sign){
      var theme=SIGN_THEMES[sign];
      if(chapter.status==='Active now')return 'You are inside the active return window. Treat the dates as a concentrated review period, not a deadline. Saturn in '+sign+' emphasizes '+theme+'.';
      if(chapter.label==='Between returns')return 'Your first return is complete. The useful work now is integration: which choices became durable, and what still needs stronger structure? Saturn in '+sign+' emphasizes '+theme+'.';
      if(chapter.status==='Upcoming')return 'Your next return is ahead. Use the dates as preparation rather than a reason to put life on hold. Saturn in '+sign+' emphasizes '+theme+'.';
      return 'This return window has passed. The work now is integration: noticing which choices became durable and what still needs stronger structure. Saturn in '+sign+' emphasizes '+theme+'.';
    }
    function resultTitleFor(state){
      if(state.chapter.label==='Between returns')return 'First return: '+formatRange(state.first)+' · Next: '+formatRange(state.second);
      if(state.chapter.relevant==='First Saturn Return')return 'Your First Saturn Return: '+formatRange(state.first);
      return 'Your Second Saturn Return: '+formatRange(state.second);
    }
    function questionFor(state){
      var focus=selectedFocus.phrase?' in '+selectedFocus.phrase:'';
      if(state.chapter.label==='Between returns')return selectedFocus.value==='overall'
        ?'What did my First Saturn Return establish, and what still needs integration in the chapter I am living now?'
        :'What did my First Saturn Return establish'+focus+', and what still needs integration now?';
      if(state.chapter.status==='Active now')return 'What is my '+state.chapter.relevant+' asking me to build, release or commit to'+focus+' right now?';
      if(state.chapter.status==='Upcoming')return 'What is my '+state.chapter.relevant+' asking me to prepare, build or release'+focus+'?';
      return 'What is my completed '+state.chapter.relevant+' asking me to integrate'+focus+' now?';
    }
    function offerTextFor(state){
      if(state.chapter.label==='Between returns')return {
        heading:'Integrate what your first Saturn Return changed',
        copy:'Use this as a retrospective integration reading: clarify what became durable, what still needs restructuring, and the next step that fits the chapter you are living now.'
      };
      if(state.chapter.status==='Active now')return {
        heading:'Navigate your active '+state.chapter.relevant+' with one clear next step',
        copy:'Your exact pass dates, natal Saturn placement and chosen focus stay attached to the reading and secure checkout.'
      };
      if(state.chapter.status==='Upcoming')return {
        heading:'Prepare for your '+state.chapter.relevant+' with a grounded plan',
        copy:'Turn your dates and natal Saturn theme into practical priorities without treating astrology as a fixed deadline.'
      };
      return {
        heading:'Integrate what your '+state.chapter.relevant+' changed',
        copy:'Use the completed timeline as a retrospective lens for what held, what needs repair, and what deserves your energy now.'
      };
    }
    function readingId(iso){
      var sectionKey=String(sid||'main').replace(/[^a-z0-9]+/gi,'-').replace(/^-+|-+$/g,'').slice(-18)||'main';
      return 'saturn-'+iso.replace(/-/g,'')+'-'+sectionKey;
    }
    function setText(node,value){if(node&&node.textContent!==value)node.textContent=value;}
    function decorateOffer(){
      Object.keys(PACKAGE_NAMES).forEach(function(tier){
        var name=PACKAGE_NAMES[tier];
        var gateOption=root.querySelector('.ddr-gate__price[data-tier="'+tier+'"]');
        var packOption=root.querySelector('.ddr-pack__opt[data-tier="'+tier+'"]');
        if(gateOption){
          setText(gateOption.querySelector('.ddr-gate__choice small'),name);
          var features=gateOption.querySelectorAll('.ddr-gate__features li');
          for(var i=0;i<features.length&&i<PACKAGE_FEATURES[tier].length;i++)setText(features[i],PACKAGE_FEATURES[tier][i]);
        }
        if(packOption){
          if(packOption.getAttribute('data-package-name')!==name)packOption.setAttribute('data-package-name',name);
          setText(packOption.querySelector('.ddr-pack__t'),name);
        }
      });
      setText(root.querySelector('.ddr-gate__depth-heading'),'Choose your Saturn reading');
      var popular=root.querySelectorAll('.ddr-gate__popular,.ddr-pack__save');
      for(var pi=0;pi<popular.length;pi++)setText(popular[pi],'Most chosen');
      var trust=root.querySelectorAll('.ddr-gate__trust li span:last-child');
      if(trust[2])setText(trust[2],'Written by hand · most within 90 min');
      var delivery=root.querySelector('.ddr-gate__delivery');
      if(delivery)delivery.open=true;
      syncDeeperPrice();
    }
    function syncDeeperPrice(){
      var price=root.querySelector('.ddr-gate__price[data-tier="deeper"] strong');
      var value=price&&price.textContent.trim();
      if(!value||value==='—'||value==='-')return;
      var labels=root.querySelectorAll('[data-saturn-deeper-price]');
      for(var i=0;i<labels.length;i++)setText(labels[i],value);
    }
    function updateSticky(){sticky.hidden=result.hidden||offerVisible;}
    function enableReading(){
      if(!readingState||!window.DeckauraDeepReading)return;
      var state=readingState;
      var focusLabel=selectedFocus.label;
      var context='Natal Saturn in '+state.sign+' at '+state.degree+' degrees. First Saturn Return '+formatRange(state.first)+' ('+state.firstStatus+'). Second Saturn Return '+formatRange(state.second)+' ('+state.secondStatus+'). Current chapter: '+state.chapter.label+'. Optional reading focus: '+focusLabel+'.';
      var offerText=offerTextFor(state);
      window.DeckauraDeepReading.enable({
        type:'Saturn Return',
        tool:'Saturn Return Calculator',
        canonicalPage:'/pages/saturn-return-calculator',
        context:context,
        signals:[
          {label:'Natal Saturn',value:state.sign+' '+state.degree+'°'},
          {label:'Current chapter',value:state.chapter.label},
          {label:'First return',value:formatRange(state.first)+' · '+state.firstStatus},
          {label:'Second return',value:formatRange(state.second)+' · '+state.secondStatus},
          {label:'Reading focus',value:focusLabel}
        ],
        signalLimit:5,
        scope:'A Saturn-sign, degree and exact return-window reflection calculated from the supplied birth date, with an optional user-selected focus.',
        confidence:'Astronomy Engine calculation. Birth-time precision was not collected or claimed.',
        readingId:readingId(state.iso),
        focus:selectedFocus.value,
        curiosityQuestion:questionFor(state),
        requireContext:false,
        defaultTier:selectedTier,
        resultReady:true,
        presentationVariant:'saturn-enterprise-v3',
        analyticsTopic:'saturn',
        title:offerText.heading,
        text:offerText.copy,
        button:'Continue to secure checkout',
        packageLabels:PACKAGE_NAMES,
        checkoutProperties:function(checkoutPackage){
          var tier=checkoutPackage&&checkoutPackage.tier||selectedTier;
          return {'Saturn package':PACKAGE_NAMES[tier]||PACKAGE_NAMES.deeper,'Birth date':state.iso,'Saturn chapter':state.chapter.label};
        },
        onTierChange:function(tier){
          if(PACKAGE_NAMES[tier])selectedTier=tier;
          window.setTimeout(decorateOffer,0);
        }
      });
      decorateOffer();
      window.setTimeout(decorateOffer,80);
      window.setTimeout(decorateOffer,500);
    }
    function saveLast(iso){
      try{localStorage.setItem(STORAGE_KEY,JSON.stringify({iso:iso,savedAt:Date.now()}));}catch(_e){}
    }
    function readLast(){
      try{
        var stored=JSON.parse(localStorage.getItem(STORAGE_KEY)||'null');
        return stored&&/^\d{4}-\d{2}-\d{2}$/.test(String(stored.iso||''))?stored:null;
      }catch(_e){return null;}
    }
    function populateIso(iso){
      var parts=String(iso||'').split('-');
      if(parts.length!==3)return false;
      month.value=String(parseInt(parts[1],10));
      day.value=String(parseInt(parts[2],10));
      year.value=parts[0];
      return !!parseBirth(false);
    }
    function showRestore(){
      var stored=readLast();
      if(!stored){restore.hidden=true;return;}
      restore.textContent='Restore last calculation · '+formatBirth(stored.iso);
      restore.hidden=false;
    }
    function calculateResult(){
      var parsed=parseBirth(true);
      if(!parsed){
        invalidateResult();
        scrollTo(form);
        var invalid=firstInvalidField();
        window.setTimeout(function(){try{invalid.focus({preventScroll:true});}catch(_e){invalid.focus();}},reduceMotion()?0:380);
        track('saturn_return_validation_error',{});
        return;
      }
      if(!window.Astronomy){
        invalidateResult();
        error.textContent='The astronomy engine is still loading. Please try again in a moment.';
        return;
      }
      calculate.disabled=true;
      calculate.textContent='Calculating your cycle…';
      error.textContent='';
      window.setTimeout(function(){
        try{
          var natal=saturnLongitude(parsed.date);
          var sign=SIGNS[Math.floor(natal/30)%12];
          var degree=(natal%30).toFixed(1);
          var first=findReturns(parsed.date,natal,28.5,31.2);
          var second=findReturns(parsed.date,natal,57.5,60.4);
          var now=new Date();
          var firstStatus=statusFor(first,now);
          var secondStatus=statusFor(second,now);
          var chapter=chooseChapter(firstStatus,secondStatus);
          readingState={iso:parsed.iso,birth:parsed.date,sign:sign,degree:degree,first:first,second:second,firstStatus:firstStatus,secondStatus:secondStatus,chapter:chapter};
          resultOverline.textContent=chapter.relevant+' · '+chapter.status;
          resultTitle.textContent=resultTitleFor(readingState);
          resultLead.textContent='Natal Saturn is '+sign+' '+degree+'°. You are in the “'+chapter.label+'” chapter; the exact passes and current phase are below.';
          clear(metrics);
          metrics.appendChild(metric('Natal Saturn',sign+' '+degree+'°','The degree Saturn returns to'));
          metrics.appendChild(metric('Current chapter',chapter.label,chapter.relevant));
          metrics.appendChild(metric('Exact passes',String(first.length+second.length),'Across first and second returns'));
          clear(returns);
          returns.appendChild(returnCard('First Saturn Return',first,firstStatus,parsed.date,chapter.relevant==='First Saturn Return'));
          returns.appendChild(returnCard('Second Saturn Return',second,secondStatus,parsed.date,chapter.relevant==='Second Saturn Return'));
          phaseBadge.textContent=chapter.label;
          phaseCopy.textContent=phaseTextFor(chapter,sign);
          var offerText=offerTextFor(readingState);
          offerHeading.textContent=offerText.heading;
          offerCopy.textContent=offerText.copy;
          result.hidden=false;
          restore.hidden=true;
          saveLast(parsed.iso);
          enableReading();
          updateSticky();
          scrollTo(result);
          window.setTimeout(function(){try{resultTitle.focus({preventScroll:true});}catch(_e){}},reduceMotion()?0:460);
          track('saturn_return_result_viewed',{natal_saturn_sign:sign,current_chapter:chapter.label,first_passes:first.length,second_passes:second.length});
        }catch(exception){
          invalidateResult();
          error.textContent='Sorry, the calculation could not be completed. Please check your birth date and try again.';
          scrollTo(form);
          track('saturn_return_calculation_error',{message:String(exception&&exception.message||'unknown')});
        }finally{
          calculate.disabled=false;
          calculate.textContent='Find My Saturn Return';
        }
      },30);
    }

    month.addEventListener('change',function(){
      clearFieldValidation(this);
      invalidateResult();
      day.focus();
    });
    var numericInputs=[day,year];
    for(var di=0;di<numericInputs.length;di++){
      numericInputs[di].addEventListener('input',function(){
        this.value=this.value.replace(/\D/g,'').slice(0,parseInt(this.getAttribute('maxlength'),10)||4);
        clearFieldValidation(this);
        invalidateResult();
        if(this===day&&this.value.length===2)year.focus();
      });
    }
    var dateInputs=[month,day,year];
    for(var ki=0;ki<dateInputs.length;ki++)dateInputs[ki].addEventListener('keydown',function(event){
      if(event.key==='Enter'){event.preventDefault();calculateResult();}
    });
    calculate.addEventListener('click',calculateResult);

    var focusButtons=root.querySelectorAll('[data-saturn-focus]');
    var focusPhrases={overall:'',career:'my career and purpose',love:'my love life and commitments',foundation:'my identity and foundations'};
    for(var fi=0;fi<focusButtons.length;fi++)focusButtons[fi].addEventListener('click',function(){
      var value=this.getAttribute('data-saturn-focus')||'overall';
      selectedFocus={value:value,label:this.getAttribute('data-label')||this.textContent.trim(),phrase:focusPhrases[value]||''};
      for(var fj=0;fj<focusButtons.length;fj++){
        var active=focusButtons[fj]===this;
        focusButtons[fj].classList.toggle('is-active',active);
        focusButtons[fj].setAttribute('aria-checked',active?'true':'false');
      }
      enableReading();
      track('saturn_return_optional_focus_selected',{focus:selectedFocus.value});
    });

    recalculate.addEventListener('click',function(){
      invalidateResult();
      clearValidation();
      showRestore();
      scrollTo(form);
      window.setTimeout(function(){month.focus({preventScroll:true});},reduceMotion()?0:380);
      track('saturn_return_recalculate',{});
    });
    restore.addEventListener('click',function(){
      var stored=readLast();
      if(!stored||!populateIso(stored.iso)){restore.hidden=true;return;}
      restore.hidden=true;
      track('saturn_return_saved_result_restored',{});
      calculateResult();
    });
    var offerLinks=root.querySelectorAll('[data-saturn-offer-link]');
    for(var oi=0;oi<offerLinks.length;oi++)offerLinks[oi].addEventListener('click',function(event){
      event.preventDefault();
      track('saturn_return_offer_shortcut_clicked',{location:this.closest('.se-sticky')?'sticky':'result'});
      scrollTo(offer);
    });

    if(typeof IntersectionObserver==='function'){
      var offerObserver=new IntersectionObserver(function(entries){
        offerVisible=entries[0]&&entries[0].isIntersecting;
        updateSticky();
      },{threshold:.12});
      offerObserver.observe(offer);
    }
    var gate=root.querySelector('#ddrGate');
    if(gate&&typeof MutationObserver==='function')new MutationObserver(function(){decorateOffer();}).observe(gate,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','aria-checked']});
    var recovery=root.querySelector('.ddr-price-recovery');
    function monitorRecovery(){
      if(!recovery)return;
      var visible=!recovery.hidden;
      if(visible&&!recoveryVisible)track('saturn_price_recovery_shown',{page:'saturn-return-calculator'});
      recoveryVisible=visible;
    }
    if(recovery&&typeof MutationObserver==='function')new MutationObserver(monitorRecovery).observe(recovery,{attributes:true,attributeFilter:['hidden','class','style']});

    function calculateWhenReady(attempt){
      if(window.Astronomy){calculateResult();return;}
      if(attempt<60)window.setTimeout(function(){calculateWhenReady(attempt+1);},100);
      else error.textContent='The astronomy engine could not be loaded. Please refresh and try again.';
    }
    function initializeSavedState(){
      var shared='';
      try{shared=new URL(window.location.href).searchParams.get('d')||'';}catch(_e){}
      if(/^\d{4}-\d{2}-\d{2}$/.test(shared)&&populateIso(shared)){
        track('saturn_return_shared_date_loaded',{});
        calculateWhenReady(0);
        return;
      }
      showRestore();
    }
    initializeSavedState();
  }
})();
